import { LoadingSpinner } from '@aibees/elephant/components/loading-spinner';
import { isAiAnalysisUnlocked } from '@aibees/elephant/components/person-ai-analysis-info/utils';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useIsPersonUpdatesPage } from '@aibees/elephant/hooks/use-is-person-updates-page';
import { ROUTES } from '@aibees/elephant/router';
import { Image } from '@aibees/shared/components';
import { useRedirect } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { AiAnalysisProfileCards } from '../ai-analysis-profile-cards';
import { PeopleAnalysisUnlockCard } from '../people-analysis-blur-overlay/components/people-analysis-unlock-card';
import { AiPersonalityHeader } from './components/ai-personality-header';
import { ConnectingInfoCard } from './components/connecting-info-card';
import { ProfileAnalysisHeader } from './components/profile-analysis-header';
import * as Styled from './styles';
import * as SX from './sx';
import type { PersonalityAnalysisPopoverProps as Props } from './types';

export const AiAnalysisContent = memo(({ className, isPopover }: Props) => {
  const { api } = usePersonReadDataContext();
  const redirect = useRedirect();
  const unlocked = isAiAnalysisUnlocked(api?.data);
  const isUpdatePage = useIsPersonUpdatesPage();

  const handleClick = () => {
    redirect(
      ROUTES.peoplePersonalityAnalysis.replace(':id', String(api?.data?.id))
    );
  };

  if ((!api?.data && unlocked) || (!api?.data && !unlocked && isPopover)) {
    return (
      <Styled.Wrapper
        className={classnames('AiAnalysisContent', className)}
        sx={SX.root({ isLoading: true, isPopover: !!isPopover, isUpdatePage })}
      >
        <LoadingSpinner textIncluded />
      </Styled.Wrapper>
    );
  }

  return (
    <Styled.Wrapper
      className={classnames('AiAnalysisContent', className)}
      sx={SX.root({ isLoading: false, isPopover: !!isPopover, isUpdatePage })}
      gap={1}
    >
      {isPopover && (
        <AiPersonalityHeader
          unlocked={unlocked}
          isPopover={!!isPopover}
          data={api?.data}
        />
      )}
      {!unlocked ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={300}
        >
          <Image src={'/assets/images/ai-personality-blured.png'} />
          <PeopleAnalysisUnlockCard isPopover={isPopover} />
        </Box>
      ) : (
        <>
          <ProfileAnalysisHeader
            archetype={
              api?.data?.revelation?.analysis?.content?.assessments?.archetype
            }
            confidenceScore={api?.data?.revelation?.analysis?.content?.score}
            onDetailsClick={handleClick}
          />

          <AiAnalysisProfileCards />

          <ConnectingInfoCard
            fullName={api?.data?.profile?.full_name}
            descriptions={
              api?.data?.revelation?.analysis?.content?.selling?.communication
                ?.descriptions || []
            }
          />
        </>
      )}
    </Styled.Wrapper>
  );
});

AiAnalysisContent.displayName = 'AiAnalysisContent';
